import { GlobalStyles } from "@mui/styled-engine";

class Globals {
    static minYear = 2010;
    static maxYear = 2021;
}

export default Globals;